module.exports = __webpack_public_path__ + "img/insper.f999a806.webp";